import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { SEO } from '../components/SEO';
import { ShieldIcon, TrendingUpIcon, UsersIcon, ArrowRightIcon, CalendarIcon, UserIcon } from 'lucide-react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { buildBreadcrumbList } from '../lib/structuredData';
export const OverOnsPage: React.FC = () => {
  const navigate = useNavigate();
  const teamMembers = [{
    name: 'Rocco',
    role: 'Oprichter & Strateeg',
    slug: 'rocco',
    bio: 'Oprichter van Noord Digital en bedenker van CorePrint. Gelooft dat elke groeibeslissing onderbouwd moet worden met data.',
    image: 'https://cdn.magicpatterns.com/uploads/6NEVZ9gbtbKb9LzgRcu9P4/image.png',
    objectPosition: 'center 60%'
  }, {
    name: 'Beer',
    role: 'SEO Specialist',
    slug: 'beer',
    bio: 'Specialist in organische groei voor B2B-bedrijven. Bouwt SEO-structuren die converteren, niet alleen ranken.',
    image: 'https://cdn.magicpatterns.com/uploads/3h5jPU9M1S7oTcbxfUFYhr/image.png',
    objectPosition: 'center 60%'
  }, {
    name: 'Alex',
    role: 'Developer',
    slug: 'alex',
    bio: 'Vertaalt strategie naar snelle, gebruiksvriendelijke websites die passen bij de merkidentiteit van de klant.',
    image: 'https://cdn.magicpatterns.com/uploads/gwFh8VhGW156sUNRdzC2Ac/image.png',
    objectPosition: 'center 60%'
  }, {
    name: 'Jelle Zwaanenburg',
    role: 'Sales Executive',
    slug: 'jelle',
    bio: 'Draait de sales voor Noord Digital. Zorgt voor het eerste contact en vertaalt jouw groeivraag naar een passend voorstel.',
    image: 'https://cdn.magicpatterns.com/uploads/5AvkpigfrYsv7QATg1Cgrc/WhatsApp_Image_2026-05-09_at_11.41.56.jpg',
    objectPosition: 'center 20%'
  }, {
    name: 'Loïs Bruins',
    role: 'Junior Vormgever',
    slug: 'lois',
    bio: 'Maakt designs voor Noord Digital. Vertaalt strategie en merk naar visueel werk dat klopt en converteert.',
    image: 'https://cdn.magicpatterns.com/uploads/o7QWtdg1j2daqsFksK5e45/WhatsApp_Image_2026-06-15_at_17.03.57_-_Copy.jpg',
    objectPosition: 'center 25%'
  }, {
    name: 'Jesse Put',
    role: 'Junior Sales Executive',
    slug: 'jesse',
    bio: 'Loopt stage bij Noord Digital om de fijne kneepjes van het sales-vak te leren van Rocco en Jelle. Frisse blik, scherpe vragen.',
    image: 'https://cdn.magicpatterns.com/uploads/8MJF64emYA1SRDFsWSY2N8/Norden_Jesse_put.png',
    objectPosition: 'center 30%'
  }, {
    name: 'Norden',
    role: 'Ads & Data Specialist',
    slug: 'norden',
    bio: 'Beheert de Google Ads-campagnes van CorePrint en zorgt dat elke euro advertentiebudget data oplevert.',
    image: 'https://cdn.magicpatterns.com/uploads/fv5nFyNt1SPvWUkxd2YKYJ/Norden_portret_300dpi_2.png',
    objectPosition: 'center 50%'
  }];
  return <div className="min-h-screen bg-white font-sans text-[#111827]" data-id="element-1910" data-mp="3e8g04nsus4ow">
      <SEO title="Over Noord Digital, het team uit Oudkarspel | Noord Digital" description="Noord Digital is een klein team uit Oudkarspel dat ondernemers in Noord-Holland Noord online zichtbaar maakt. Maak kennis met de mensen achter het werk." keywords="over noord digital, team noord digital, webbureau Oudkarspel, marketingbureau Dijk en Waard" canonical="https://noorddigital.nl/over-ons" jsonLd={buildBreadcrumbList([{
      name: 'Over ons',
      path: '/over-ons'
    }])} data-id="element-1911" data-mp="3iauo1mbdpun1" />
      <Header data-id="element-1912" data-mp="1qbqfdj5nq2zl" />

      {/* Section 1 — Hero */}
      <section className="pt-32 pb-20 lg:pt-40 lg:pb-24 bg-gradient-to-b from-[#FFFFFF] to-[#EEF5FA]" data-id="element-1913" data-mp="1qemdb7hi8ro1">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1914" data-mp="1lg196wz4tnub">
          <div className="flex flex-col lg:flex-row items-center justify-between gap-12 lg:gap-20" data-id="element-1915" data-mp="1zcy0ezj5x7bq">
            <div className="lg:w-1/2" data-id="element-1916" data-mp="1uewgkcdwx3z7">
              <motion.h1 initial={{
              opacity: 0,
              y: 20
            }} animate={{
              opacity: 1,
              y: 0
            }} className="text-4xl md:text-5xl lg:text-6xl font-bold text-[#111827] leading-tight mb-6" data-id="element-1917" data-mp="4zgns7kapuvh">
                Het team achter Noord Digital
              </motion.h1>
              <motion.p initial={{
              opacity: 0,
              y: 20
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              delay: 0.1
            }} className="text-lg md:text-xl text-[#4B5563] leading-relaxed mb-8" data-id="element-1918" data-mp="6fue8vovetxd">
                Wij zijn een klein, gedreven team van specialisten die geloven
                dat online groei begint met bewijs en niet met aannames.
              </motion.p>
              <motion.div initial={{
              opacity: 0,
              y: 20
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              delay: 0.2
            }} data-id="element-1919" data-mp="3ouli4a4w5svu">
                <a href="#team" className="inline-flex items-center gap-2 px-6 py-3 bg-[#004AC7] text-white font-semibold rounded-lg hover:bg-[#003A9E] transition-colors shadow-md" data-id="element-1920" data-mp="2w6pml8r2670n">
                  Ontmoet het team <ArrowRightIcon className="w-5 h-5" data-id="element-1921" data-mp="2tlrn1q8ukitt" />
                </a>
              </motion.div>
            </div>
            <div className="lg:w-1/2 w-full" data-id="element-1922" data-mp="2onq4d6fc2liv">
              <motion.div initial={{
              opacity: 0,
              scale: 0.95
            }} animate={{
              opacity: 1,
              scale: 1
            }} transition={{
              delay: 0.2,
              duration: 0.5
            }} className="relative rounded-2xl overflow-hidden shadow-2xl aspect-[4/3]" data-id="element-1923" data-mp="2okkbdg3l2zhv">
                <img src="https://cdn.magicpatterns.com/uploads/au6CUb9MtiVsZo5hShj5nJ/IMG_2983.jpg" alt="Het team van Noord Digital voor het kantoor met het Noord-bord" className="w-full h-full object-cover" data-id="element-1924" data-mp="25vnh3c86s6zn" />
                <div className="absolute inset-0 bg-gradient-to-tr from-[#004AC7]/15 to-transparent mix-blend-multiply" data-id="element-1925" data-mp="1vysp7c6f54uc"></div>
              </motion.div>
            </div>
          </div>
        </div>
      </section>

      {/* Section 2 — Onze missie */}
      <section className="py-24 bg-white" data-id="element-1926" data-mp="1cbxs7dj7uaxy">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1927" data-mp="1cawf73in3edl">
          <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-1928" data-mp="1haslxaiq1jwu">
            <h2 className="text-3xl md:text-4xl font-bold mb-6 text-[#111827]" data-id="element-1929" data-mp="1hcbz2s92zeue">
              Waarom Noord Digital?
            </h2>
            <p className="text-[#4B5563] text-lg leading-relaxed mb-4" data-id="element-1930" data-mp="18a2rob9401l8">
              Bij Noord Digital geloven we in eerlijkheid over wat werkt. Geen
              loze beloftes of vage marketingtermen, maar een heldere aanpak
              gebaseerd op data en bewezen strategieën.
            </p>
            <p className="text-[#4B5563] text-lg leading-relaxed" data-id="element-1931" data-mp="1madjbgi8tk7g">
              We gaan voor lange termijn partnerships. Jouw succes is ons
              succes. Daarom werken we nauw met je samen, als een verlengstuk
              van je eigen team.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-1932" data-mp="2ewye6qxxgefr">
            <motion.div whileHover={{
            y: -5
          }} className="bg-[#F7F8FA] p-8 rounded-2xl border border-gray-100 shadow-sm" data-id="element-1933" data-mp="2jr2if2ft68d5">
              <div className="bg-white w-14 h-14 rounded-xl flex items-center justify-center text-[#004AC7] mb-6 shadow-sm" data-id="element-1934" data-mp="2p2zjwwms0qb3">
                <ShieldIcon className="w-7 h-7" data-id="element-1935" data-mp="32ue7lgrmpfoh" />
              </div>
              <h3 className="text-xl font-bold mb-3 text-[#111827]" data-id="element-1936" data-mp="2xv1lwzchuenh">
                Geen verborgen kosten
              </h3>
              <p className="text-[#4B5563] leading-relaxed" data-id="element-1937" data-mp="2a4p3uvnjb1j6">
                We zijn transparant in onze werkwijze en prijzen. Je weet altijd
                precies waar je aan toe bent, zonder verrassingen achteraf.
              </p>
            </motion.div>

            <motion.div whileHover={{
            y: -5
          }} className="bg-[#F7F8FA] p-8 rounded-2xl border border-gray-100 shadow-sm" data-id="element-1938" data-mp="2k1aaflf7ckp4">
              <div className="bg-white w-14 h-14 rounded-xl flex items-center justify-center text-[#004AC7] mb-6 shadow-sm" data-id="element-1939" data-mp="3vhqsznm1zhg7">
                <TrendingUpIcon className="w-7 h-7" data-id="element-1940" data-mp="3qjgv358y22qw" />
              </div>
              <h3 className="text-xl font-bold mb-3 text-[#111827]" data-id="element-1941" data-mp="1ovko8c7kiuk3">
                Data-gedreven groei
              </h3>
              <p className="text-[#4B5563] leading-relaxed" data-id="element-1942" data-mp="1swedb8wqyfek">
                We meten alles, analyseren de resultaten en sturen bij waar
                nodig voor maximaal rendement. Aannames laten we aan anderen
                over.
              </p>
            </motion.div>

            <motion.div whileHover={{
            y: -5
          }} className="bg-[#F7F8FA] p-8 rounded-2xl border border-gray-100 shadow-sm" data-id="element-1943" data-mp="27k96srikwnsp">
              <div className="bg-white w-14 h-14 rounded-xl flex items-center justify-center text-[#004AC7] mb-6 shadow-sm" data-id="element-1944" data-mp="2clykyg13lhl0">
                <UsersIcon className="w-7 h-7" data-id="element-1945" data-mp="2llbvzd4vee7u" />
              </div>
              <h3 className="text-xl font-bold mb-3 text-[#111827]" data-id="element-1946" data-mp="2lify1ot0vpje">
                Persoonlijk contact
              </h3>
              <p className="text-[#4B5563] leading-relaxed" data-id="element-1947" data-mp="r6iz7as93heb">
                Korte lijntjes en snelle communicatie met één dedicated
                contactpersoon die jouw bedrijf en markt door en door kent.
              </p>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Section 3 — Team grid */}
      <section id="team" className="py-24 bg-[#F7F8FA]" data-id="element-1948" data-mp="9yi0zi9zdeik">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1949" data-mp="4ydixntfcbq8">
          <div className="text-center mb-16" data-id="element-1950" data-mp="506spbzc3c2g">
            <h2 className="text-3xl md:text-4xl font-bold mb-4 text-[#111827]" data-id="element-1951" data-mp="12mnqeibzbroq">
              Maak kennis met ons team
            </h2>
            <p className="text-lg text-[#4B5563]" data-id="element-1952" data-mp="xnkjescfvbe4">
              De specialisten die bouwen aan jouw online succes.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-1953" data-mp="omcv933mzqxr">
            {teamMembers.map((member, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} whileHover={{
            y: -8
          }} className="bg-white rounded-2xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-300 flex flex-col h-full group cursor-pointer border border-gray-100" onClick={() => navigate(`/over-ons/${member.slug}`)} data-id="element-1954" data-mp="3deoyt85pshjf" data-mpi={index}>
                <div className="relative h-64 w-full overflow-hidden bg-[#EEF5FA]" data-id="element-1955" data-mp="1eso6s83j9zx3">
                  {member.image ? <img src={member.image} alt={member.name} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" style={{
                objectPosition: member.objectPosition
              }} data-id="element-1956" data-mp="1th298hx1fmd4" /> : <div className="w-full h-full flex items-center justify-center bg-gradient-to-br from-[#EEF5FA] to-[#DCE9F5]" data-id="element-1957" data-mp="1xkgze1eoxj4a">
                      <div className="w-28 h-28 rounded-full bg-white/80 border-4 border-white shadow-inner flex items-center justify-center" data-id="element-1958" data-mp="84r08yfq1q8p">
                        <UserIcon className="w-14 h-14 text-[#9CA3AF]" strokeWidth={1.5} data-id="element-1959" data-mp="38aeubzwppzb" />
                      </div>
                    </div>}
                </div>
                <div className="p-6 flex-grow flex flex-col" data-id="element-1960" data-mp="2jrugy4omiaxv">
                  <h3 className="text-xl font-bold text-[#111827] mb-1 group-hover:text-[#004AC7] transition-colors" data-id="element-1961" data-mp="261h9e3fn8y92">
                    {member.name}
                  </h3>
                  <p className="text-sm font-semibold text-[#004AC7] mb-4 uppercase tracking-wide" data-id="element-1962" data-mp="2a0zvh2j7bfdh">
                    {member.role}
                  </p>
                  <p className="text-[#4B5563] text-sm leading-relaxed mb-6 flex-grow" data-id="element-1963" data-mp="212o4v0ic4hl1">
                    {member.bio}
                  </p>
                  <div className="text-[#111827] font-semibold flex items-center gap-2 group-hover:text-[#004AC7] transition-colors mt-auto" data-id="element-1964" data-mp="1n4pvyams9dcx">
                    Bekijk profiel{' '}
                    <ArrowRightIcon className="w-4 h-4 transform group-hover:translate-x-1 transition-transform" data-id="element-1965" data-mp="3hh5x4x0q21ax" />
                  </div>
                </div>
              </motion.div>)}
          </div>
        </div>
      </section>

      {/* Section 4 — Personal Contact CTA */}
      <section className="py-24 bg-white overflow-hidden" data-id="element-1966" data-mp="t9nvu18afziu">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1967" data-mp="p94277mxbe1g">
          <div className="bg-[#004AC7] rounded-3xl overflow-hidden shadow-2xl relative" data-id="element-1968" data-mp="p9dtcyjpfr8q">
            {/* Decorative background elements */}
            <div className="absolute top-0 right-0 w-64 h-64 bg-white opacity-5 rounded-full blur-3xl -mr-20 -mt-20" data-id="element-1969" data-mp="1h01qlzi9cch4"></div>
            <div className="absolute bottom-0 left-0 w-80 h-80 bg-[#002A7A] opacity-50 rounded-full blur-3xl -ml-20 -mb-20" data-id="element-1970" data-mp="1cygam5affi2p"></div>

            <div className="flex flex-col md:flex-row items-center relative z-10" data-id="element-1971" data-mp="18657yuoaxi6g">
              <div className="md:w-1/2 p-10 md:p-16 lg:p-20 flex flex-col justify-center" data-id="element-1972" data-mp="1383qufafrsxm">
                <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-6 leading-tight" data-id="element-1973" data-mp="20pc4d7yg0ncl">
                  Benieuwd wat we voor jou kunnen betekenen?
                </h2>
                <p className="text-xl text-white/90 mb-10 leading-relaxed" data-id="element-1974" data-mp="239iclru3azyy">
                  Geen gladde verkooppraatjes, maar een eerlijk gesprek over
                  jouw groeikansen. Plan een kennismaking met Rocco.
                </p>
                <div className="flex flex-col sm:flex-row gap-4" data-id="element-1975" data-mp="2d8zerza4uvq6">
                  <a href="/#contact" className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-white text-[#004AC7] font-bold rounded-xl hover:bg-gray-50 transition-colors duration-300 shadow-lg text-lg" data-id="element-1976" data-mp="2h9je99i6ibfh">
                    <CalendarIcon className="w-5 h-5" data-id="element-1977" data-mp="2r531z8mla3t5" /> Plan een kennismaking
                  </a>
                </div>
              </div>
              <div className="md:w-1/2 w-full h-full min-h-[400px] relative" data-id="element-1978" data-mp="30wh83z91q1v9">
                <img src="https://cdn.magicpatterns.com/uploads/bHpW8bmTGE8GfDnPuTgcdC/image.png" alt="Rocco van Noord Digital" className="absolute inset-0 w-full h-full object-cover object-center" data-id="element-1979" data-mp="30yk20udbkf59" />
                {/* Gradient overlay to blend image with background on mobile */}
                <div className="absolute inset-0 bg-gradient-to-t from-[#004AC7] to-transparent md:bg-gradient-to-r md:from-[#004AC7] md:to-transparent w-full h-full opacity-60 md:opacity-100 md:w-1/3" data-id="element-1980" data-mp="2w8ltw0vnygh7"></div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer data-id="element-1981" data-mp="311opsfnwy20k" />
    </div>;
};